import React, { useEffect, useMemo, useRef, useState, useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { FRONT_DEFAULT_AVATAR, resolveAvatarUrl, withAvatarFallback } from '../../utils/avatar';
import Вова from './Вова.jpg'
import Котеры from './Котеры.jpg'
import Оля from './Оля.jpg'
import Машуля from './Машуля.jpg'
import Союз_кистей_и_мысли from './Союз_кистей_и_мысли.jpg'
import Книги_это_любовь from './Книги_это_любовь.jpg'
import Настя from './Настя.jpg'
import фото from './фото.jpg'
import { API_BASE, MESSENGER_API_BASE, NOTIFICATION_API_BASE } from '../../config';
import useOnboardingGuard from '../../hooks/useOnboardingGuard';

const demoChats = [
  { id: 1, name: 'Клуб анонимных игроманов', message: <span><span className="chats-item-sender-name">Никита: </span>Я сегодня занят</span>, time: '19:48', unread: 1, avatar: 'https://placehold.co/50x50/8BABD8/white?text=K', type: 'group' },
  { id: 2, name: 'Котеры', message: <span><span className="chats-item-sender-name">Аня: </span>У меня есть печеньки :D</span>, time: '18:30', unread: 2, avatar: Котеры, type: 'group' },
  { id: 3, name: 'Владимир', message: <span><span className="chats-item-sender-name">Владимир: </span>Я с радостью. Сегодня в 18:00 😊</span>, time: '18:16', active: true, avatar: Вова },
  { id: 4, name: 'Настя', message: <span><span className="chats-item-sender-name">Вы: </span>Я уехала жить в Лондон 🎉🚀</span>, time: '18:02', avatar: Настя },
  { id: 5, name: 'Машуля', message: <span><span className="chats-item-sender-name">Вы: </span>Зацени мем))</span>, time: '17:42', avatar: Машуля },
  { id: 6, name: 'Книги — это любовь', message: <span><span className="chats-item-sender-name">Илья: </span>Всем советую почитать Мастер и Маргарита 😌</span>, time: '17:08', avatar: Книги_это_любовь, type: 'group' },
  { id: 7, name: 'Артемий', message: <span><span className="chats-item-sender-name">Артемий: </span>Наши выиграли со счётом 4:2</span>, time: '16:15', avatar: 'https://placehold.co/50x50/90EE90/white?text=A' },
  { id: 8, name: 'Оля', message: <span><span className="chats-item-sender-name">Оля: </span>Я на месте 💜</span>, time: 'Ср', avatar: Оля },
  { id: 9, name: 'Союз кистей и мысли', message: <span><span className="chats-item-sender-name">Эмили: </span><img src={фото} alt="фото" className="w-4 h-4 inline-block object-cover rounded-sm mx-1"/> Афигенно</span>, time: 'Чт', avatar: Союз_кистей_и_мысли, type: 'group' },
];

const demoMessages = [
  { id: 'demo-1', direction: 'in', text: 'Привет! Давай сходим сегодня в кино?', time: '18:12', createdAt: '2025-12-01T18:12:00' },
  { id: 'demo-2', direction: 'out', text: 'Привет', time: '18:15', createdAt: '2025-12-01T18:15:00' },
  { id: 'demo-3', direction: 'out', text: 'Я с радостью. Сегодня в 18:00? 😊', time: '18:16', createdAt: '2025-12-01T18:16:00' }
];

const safeParseJson = (value) => {
  if (!value) return null;
  if (typeof value === 'object') return value;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const normalizeNotification = (raw) => ({
  id: raw?.id || raw?.Id,
  type: (raw?.type || raw?.Type || '').trim(),
  payloadJson: raw?.payloadJson ?? raw?.PayloadJson
});

const mapMessageNotifications = (rawList) => {
  if (!Array.isArray(rawList)) return [];
  return rawList
    .map(normalizeNotification)
    .filter((item) => item.type === 'message_received')
    .map((item) => {
      const payload = safeParseJson(item.payloadJson);
      const conversationId = payload?.conversationId;
      if (!item.id || !conversationId) return null;
      return { id: item.id, conversationId };
    })
    .filter(Boolean);
};

const buildUnreadByConversation = (notifications) => {
  const map = {};
  notifications.forEach((item) => {
    map[item.conversationId] = (map[item.conversationId] || 0) + 1;
  });
  return map;
};

const getStoredUserId = () => {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.userId || parsed?.UserId || null;
  } catch {
    return null;
  }
};

const resolveAttachmentUrl = (attachment) => {
  if (!attachment) return '';
  const url = attachment.url || attachment.Url || attachment.relativePath || attachment.RelativePath;
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('blob:')) {
    return url;
  }
  if (process.env.NODE_ENV !== 'development') {
    return url.startsWith('/') ? url : `/${url}`;
  }
  return `${MESSENGER_API_BASE}${url.startsWith('/') ? '' : '/'}${url}`;
};

const formatChatTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
};

const formatMessageTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
};

const buildDisplayName = (profile) => {
  const fullName = [profile?.firstName, profile?.lastName].filter(Boolean).join(' ').trim();
  return fullName || profile?.nickname || 'Без имени';
};

const buildMessagePreview = (text, senderId, currentUserId, chatName) => {
  const content = (text || '').trim();
  if (!content) return '';

  // Check if it's an outgoing message
  if (senderId === currentUserId) {
    return <span><span className="chats-item-sender-name">Вы: </span>{content}</span>;
  }

  // Prefix with sender name for incoming messages
  if (chatName) {
    return <span><span className="chats-item-sender-name">{chatName}: </span>{content}</span>;
  }

  return content;
};

const formatUserStatus = (isOnline, lastSeenAt) => {
  if (isOnline) return 'в сети';
  if (!lastSeenAt) return 'был(а) недавно';
  
  const date = new Date(lastSeenAt);
  if (Number.isNaN(date.getTime())) return 'был(а) недавно';

  const now = new Date();
  const diffMs = now - date;
  const diffMinutes = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMinutes < 60) {
    return `был(а) в сети ${diffMinutes} мин. назад`;
  } else if (diffHours < 24) {
    return `был(а) в сети ${diffHours} ч. назад`;
  } else if (diffDays === 1) {
    return 'был(а) в сети вчера';
  } else {
    const options = { day: 'numeric', month: 'long' };
    return `был(а) в сети ${date.toLocaleDateString('ru-RU', options)}`;
  }
};

const buildChatItem = ({ profile, otherUserId, conversationId, createdAt, lastMessage, currentUserId, isBackend }) => {
  const name = buildDisplayName(profile);
  const message = lastMessage
    ? buildMessagePreview(lastMessage.text, lastMessage.senderId, currentUserId, name)
    : '';
  const timeSource = lastMessage?.createdAt || createdAt;

  return {
    id: conversationId,
    name,
    message,
    time: timeSource ? formatChatTime(timeSource) : '',
    activityAt: timeSource || null,
    unread: 0,
    avatar: profile?.avatarUrl ? resolveAvatarUrl(profile.avatarUrl) : FRONT_DEFAULT_AVATAR,
    type: 'direct',
    otherUserId,
    isBackend,
    isPending: !isBackend,
    isOnline: profile?.isOnline || false,
    lastSeenAt: profile?.lastSeenAt || null
  };
};

const fetchProfileById = async (userId, token) => {
  if (!userId || !token) return null;

  try {
    const profileResponse = await fetch(`${API_BASE}/api/Profile/by-id/${userId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!profileResponse.ok) return null;
    return await profileResponse.json();
  } catch {
    return null;
  }
};

const formatDateLabel = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const dayMonth = date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
  return `${dayMonth} ${date.getFullYear()} год`;
};

const isOutgoingMessage = (message, currentUserId) => {
  if (message?.senderId && currentUserId) {
    return String(message.senderId) === String(currentUserId);
  }
  return message?.direction === 'out';
};

const normalizeQuery = (value) => value.trim().toLowerCase();

const toActivityEpoch = (value) => {
  if (!value) return 0;
  const date = new Date(value);
  const epoch = date.getTime();
  return Number.isNaN(epoch) ? 0 : epoch;
};

const sortChatsByActivity = (items) => (
  [...items].sort((a, b) => {
    const diff = toActivityEpoch(b.activityAt) - toActivityEpoch(a.activityAt);
    if (diff !== 0) return diff;
    return String(a.id).localeCompare(String(b.id));
  })
);

const buildMessageRows = (messages) => {
  const rows = [];
  let lastDateKey = null;

  messages.forEach((message) => {
    const createdAt = message?.createdAt;
    const date = createdAt ? new Date(createdAt) : null;
    const dateKey = date && !Number.isNaN(date.getTime()) ? date.toDateString() : null;

    if (dateKey && dateKey !== lastDateKey) {
      rows.push({ type: 'date', id: `date-${dateKey}`, label: formatDateLabel(createdAt) });
      lastDateKey = dateKey;
    }

    rows.push({ type: 'message', id: message.id, message });
  });

  return rows;
};

const getMessageMarginTop = (row, index, rows, currentUserId) => {
  if (index === 0) return 0;
  const prevRow = rows[index - 1];
  if (prevRow.type === 'date') {
    return 0; // Spacing is handled by date divider margin-bottom
  }
  
  if (prevRow.type === 'message') {
    const currentMsg = row.message;
    const prevMsg = prevRow.message;
    const currentIsOutgoing = isOutgoingMessage(currentMsg, currentUserId);
    const prevIsOutgoing = isOutgoingMessage(prevMsg, currentUserId);
    
    if (currentIsOutgoing === prevIsOutgoing) {
      const t1 = new Date(currentMsg.createdAt).getTime();
      const t2 = new Date(prevMsg.createdAt).getTime();
      if (!Number.isNaN(t1) && !Number.isNaN(t2)) {
        const diffMs = Math.abs(t1 - t2);
        return diffMs < 120000 ? 5 : 8; // 5px for close, 8px for large gap
      }
      return 8; // fallback
    } else {
      return 8; // different senders
    }
  }
  return 0;
};

function Chats() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loading: onboardingLoading } = useOnboardingGuard();
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/log_in');
    }
  }, [navigate]);
  const chatContainerRef = useRef(null);
  const prevScrollHeightRef = useRef(null);
  const isNearBottomRef = useRef(true);
  const lastSelectedChatIdRef = useRef(null);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [chatItems, setChatItems] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [showChatPanel, setShowChatPanel] = useState(false); // Default to list on mobile
  const [showScrollToBottom, setShowScrollToBottom] = useState(false);
  const [chatFilterQuery, setChatFilterQuery] = useState('');

  useEffect(() => {
    // When a chat is selected, save it to sessionStorage and manage panel visibility
    if (selectedChat) {
      sessionStorage.setItem('lastSelectedChatId', selectedChat.id);
      setShowChatPanel(true);
    } else {
      // If we are on desktop, we might still want the panel, but on mobile definitely not
      if (window.innerWidth < 768) {
        setShowChatPanel(false);
      }
    }
  }, [selectedChat]);
  const [messagesByChatId, setMessagesByChatId] = useState({});
  const [searchResultsByChatId, setSearchResultsByChatId] = useState({});
  const [blockedByChatId, setBlockedByChatId] = useState({});
  const [hasMoreHistoryByChatId, setHasMoreHistoryByChatId] = useState({});
  const [messageText, setMessageText] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);
  const [lightbox, setLightbox] = useState({ isOpen: false, images: [], currentIndex: 0 });
  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [messageNotifications, setMessageNotifications] = useState([]);
  const notificationsPolling = useRef(null);
  const lastMessageCountRef = useRef(0);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const emojiPickerRef = useRef(null);
  const currentUserId = getStoredUserId();
  const unreadByConversation = useMemo(
    () => buildUnreadByConversation(messageNotifications),
    [messageNotifications]
  );
  const isPendingChat = Boolean(selectedChat?.isPending);
  const isDemoChat = Boolean(selectedChat && !selectedChat.isBackend && !selectedChat.isPending);
  const activeMessages = selectedChat?.isBackend
    ? (messagesByChatId[selectedChat.id] || [])
    : (isDemoChat ? demoMessages : []);
  const normalizedQuery = normalizeQuery(searchQuery);
  const demoSearchMessages = normalizedQuery
    ? demoMessages.filter((message) => (message.text || '').toLowerCase().includes(normalizedQuery))
    : demoMessages;
  const searchResults = selectedChat?.isBackend
    ? (searchResultsByChatId[selectedChat.id] || [])
    : [];
  const displayMessages = normalizedQuery
    ? (selectedChat?.isBackend ? searchResults : (isDemoChat ? demoSearchMessages : []))
    : activeMessages;
  const messageRows = buildMessageRows(displayMessages);
  const isBlocked = selectedChat ? Boolean(blockedByChatId[selectedChat.id]) : false;

  const [isSearching, setIsSearching] = useState(false);
  const [inlineSearchQuery, setInlineSearchQuery] = useState('');
  const [currentSearchIndex, setCurrentSearchIndex] = useState(0);

  const matchedMessageIds = useMemo(() => {
    if (!inlineSearchQuery.trim() || !activeMessages) return [];
    const q = inlineSearchQuery.toLowerCase().trim();
    return activeMessages
      .filter(m => m.text && m.text.toLowerCase().includes(q))
      .map(m => m.id);
  }, [inlineSearchQuery, activeMessages]);

  useEffect(() => {
    if (!showEmojiPicker) return undefined;

    const handlePointerDownOutside = (event) => {
      if (!emojiPickerRef.current?.contains(event.target)) {
        setShowEmojiPicker(false);
      }
    };

    document.addEventListener('mousedown', handlePointerDownOutside);
    document.addEventListener('touchstart', handlePointerDownOutside);

    return () => {
      document.removeEventListener('mousedown', handlePointerDownOutside);
      document.removeEventListener('touchstart', handlePointerDownOutside);
    };
  }, [showEmojiPicker]);

  useEffect(() => {
    setCurrentSearchIndex(0);
  }, [inlineSearchQuery]);

  const scrollToMessageId = (id) => {
    const el = document.getElementById(`msg-${id}`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const handlePrevMatch = () => {
    if (matchedMessageIds.length === 0) return;
    const nextIndex = (currentSearchIndex - 1 + matchedMessageIds.length) % matchedMessageIds.length;
    setCurrentSearchIndex(nextIndex);
    scrollToMessageId(matchedMessageIds[nextIndex]);
  };

  const handleNextMatch = () => {
    if (matchedMessageIds.length === 0) return;
    const nextIndex = (currentSearchIndex + 1) % matchedMessageIds.length;
    setCurrentSearchIndex(nextIndex);
    scrollToMessageId(matchedMessageIds[nextIndex]);
  };

  const handleJumpToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
      setShowScrollToBottom(false);
      isNearBottomRef.current = true;
    }
  };

   // NEW: Auto-sync conversations for any existing mutual likes
   useEffect(() => {
     const runSync = async () => {
       const token = localStorage.getItem('token');
       if (!token) return;
       try {
         // This endpoint ensures conversations exist for all mutual likes
         await fetch(`${API_BASE}/api/Likes/sync-conversations`, {
           method: 'POST',
           headers: { 'Authorization': `Bearer ${token}` }
         });
       } catch (error) {
         console.warn("Failed to sync conversations", error);
       }
     };
     runSync();
   }, []);

  useEffect(() => {
    let isActive = true;
    const requestedUserId = new URLSearchParams(location.search).get('userId')?.trim();

    const loadConversations = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        const response = await fetch(`${MESSENGER_API_BASE}/api/conversations`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) return;

        const data = await response.json();
        const conversations = Array.isArray(data) ? data : [];

        const userId = getStoredUserId();
        const chatsFromApi = await Promise.all(conversations.map(async (conversation) => {
          const participants = Array.isArray(conversation.participantIds)
            ? conversation.participantIds
            : [];
          const otherUserId = participants.find((id) => id !== userId) || participants[0] || '';

          const profile = await fetchProfileById(otherUserId, token);

          return buildChatItem({
            profile,
            otherUserId,
            conversationId: conversation.id,
            createdAt: conversation.createdAt,
            lastMessage: conversation.lastMessage,
            currentUserId: userId,
            isBackend: true
          });
        }));

        let pendingChat = null;

        if (requestedUserId) {
          pendingChat = chatsFromApi.find((chat) => chat.otherUserId === requestedUserId) || null;

          if (!pendingChat) {
            const profile = await fetchProfileById(requestedUserId, token);
            pendingChat = buildChatItem({
              profile,
              otherUserId: requestedUserId,
              conversationId: `pending-${requestedUserId}`,
              createdAt: null,
              lastMessage: null,
              currentUserId: userId,
              isBackend: false
            });
          }
        }

        const sortedChats = sortChatsByActivity(chatsFromApi);

        const isMobile = window.innerWidth < 768;
        const isReload = performance.getEntriesByType("navigation")[0]?.type === 'reload';
        const lastChatId = sessionStorage.getItem('lastSelectedChatId');

        if (!isActive) return;
        setChatItems(sortedChats);
        
        if (pendingChat) {
          setSelectedChat(pendingChat);
        } else if (lastChatId && (!isMobile || !isReload)) {
          const restored = sortedChats.find(c => String(c.id) === String(lastChatId));
          if (restored) {
            setSelectedChat(restored);
          } else {
            setSelectedChat(null);
          }
        } else {
          // On mobile reload we intentionally reset to the chat list.
          setSelectedChat(null);
        }
      } catch (error) {
        console.error('Messenger load error:', error);
      }
    };

    loadConversations();

    return () => {
      isActive = false;
    };
  }, [location.search]);

  useEffect(() => {
    let isActive = true;

    const loadNotifications = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        if (isActive) setMessageNotifications([]);
        return;
      }

      try {
        const response = await fetch(`${NOTIFICATION_API_BASE}/api/notifications`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          if (response.status === 401 && isActive) setMessageNotifications([]);
          return;
        }

        const data = await response.json();
        if (!isActive) return;

        const mapped = mapMessageNotifications(data);
        setMessageNotifications(mapped);
      } catch (error) {
        console.error('Notifications load error:', error);
      }
    };

    loadNotifications();
    notificationsPolling.current = window.setInterval(loadNotifications, 8000);

    return () => {
      isActive = false;
      if (notificationsPolling.current) window.clearInterval(notificationsPolling.current);
    };
  }, []);

  useEffect(() => {
    let isActive = true;
    const conversationId = selectedChat?.id;
    if (!selectedChat?.isBackend || !conversationId) return undefined;

    const loadMessages = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        fetch(`${MESSENGER_API_BASE}/api/conversations/${conversationId}/messages/read`, {
            method: 'PUT',
            headers: { 'Authorization': `Bearer ${token}` }
        }).catch(() => {});

        const response = await fetch(`${MESSENGER_API_BASE}/api/conversations/${conversationId}/messages?limit=50`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) return;

        const data = await response.json();
        const mapped = Array.isArray(data)
          ? data.map((message) => ({
              id: message.id,
              senderId: message.senderId,
              text: message.text,
              isRead: message.isRead,
              createdAt: message.createdAt,
              attachments: message.attachments || []
            }))
          : [];

        if (!isActive) return;

        setMessagesByChatId((prev) => {
          const current = prev[conversationId] || [];
          const combined = [...current, ...mapped];
          const uniqueMap = new Map();
          combined.forEach(msg => {
              if (msg && msg.id) {
                  uniqueMap.set(msg.id, msg);
              }
          });
          const deduplicated = Array.from(uniqueMap.values());
          deduplicated.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
          return {
              ...prev,
              [conversationId]: deduplicated
          };
        });

        if (mapped.length > 0) {
          const lastMessage = mapped[mapped.length - 1];
          setChatItems((prev) => sortChatsByActivity(prev.map((chat) => (
            chat.id === conversationId
              ? {
                  ...chat,
                  message: buildMessagePreview(lastMessage.text, lastMessage.senderId, currentUserId, chat.name),
                  time: formatChatTime(lastMessage.createdAt),
                  activityAt: lastMessage.createdAt
                }
              : chat
          ))));
        }
      } catch (error) {
        console.error('Messages load error:', error);
      }
    };

    loadMessages();
    const intervalId = setInterval(loadMessages, 5000);

    return () => {
      isActive = false;
      clearInterval(intervalId);
    };
  }, [selectedChat?.id, selectedChat?.isBackend]);

  useEffect(() => {
    if (!selectedChat?.isBackend || !selectedChat?.id) return;
    const idsToRead = messageNotifications
      .filter((item) => item.conversationId === selectedChat.id)
      .map((item) => item.id);
    if (idsToRead.length === 0) return;

    const token = localStorage.getItem('token');
    if (!token) return;

    const markRead = async () => {
      try {
        await Promise.all(idsToRead.map((id) => (
          fetch(`${NOTIFICATION_API_BASE}/api/notifications/${id}/read`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`
            }
          }).catch(() => null)
        )));
      } catch (error) {
        console.error('Notification read error:', error);
      }

      setMessageNotifications((prev) => prev.filter((item) => !idsToRead.includes(item.id)));
    };

    markRead();
  }, [selectedChat?.id, selectedChat?.isBackend, messageNotifications]);

  useEffect(() => {
    if (isBlocked) {
      setMessageText('');
    }
  }, [isBlocked]);

  useEffect(() => {
    setSearchQuery('');
  }, [selectedChat?.id]);

  useEffect(() => {
    let isActive = true;

    const loadBlockStatus = async () => {
      if (!selectedChat?.isBackend || !selectedChat.otherUserId) return;

      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        let cursor = null;
        let blocked = false;

        do {
          const params = new URLSearchParams({ count: '100' });
          if (cursor) {
            params.set('cursor', cursor);
          }

          const response = await fetch(`${API_BASE}/api/Likes/blacklist?${params.toString()}`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });

          if (!response.ok) return;

          const data = await response.json();
          const items = Array.isArray(data?.items) ? data.items : [];
          blocked = items.some((item) => item?.id === selectedChat.otherUserId || item?.Id === selectedChat.otherUserId);
          cursor = data?.nextCursor;
        } while (!blocked && cursor);

        if (!isActive) return;
        setBlockedByChatId((prev) => ({ ...prev, [selectedChat.id]: blocked }));
      } catch (error) {
        console.error('Block status error:', error);
      }
    };

    loadBlockStatus();

    return () => {
      isActive = false;
    };
  }, [selectedChat?.id, selectedChat?.otherUserId, selectedChat?.isBackend]);
  
  useEffect(() => {
    if (messageText === '') {
      const textarea = document.querySelector('.chats-input-field');
      if (textarea) {
        textarea.style.height = 'auto';
      }
    }
  }, [messageText]);

  useEffect(() => {
    let isActive = true;

    if (!selectedChat?.isBackend) {
      return () => {
        isActive = false;
      };
    }

    if (!normalizedQuery) {
      setSearchResultsByChatId((prev) => {
        if (!prev[selectedChat?.id]) return prev;
        const next = { ...prev };
        delete next[selectedChat.id];
        return next;
      });
      return () => {
        isActive = false;
      };
    }

    const token = localStorage.getItem('token');
    if (!token) {
      return () => {
        isActive = false;
      };
    }

    const timeoutId = setTimeout(async () => {
      try {
        const params = new URLSearchParams({
          query: normalizedQuery,
          conversationId: selectedChat.id
        });

        const response = await fetch(`${MESSENGER_API_BASE}/api/messages/search?${params.toString()}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) return;

        const data = await response.json();
        const mapped = Array.isArray(data)
          ? data.map((message) => ({
              id: message.id,
              senderId: message.senderId,
              text: message.text,
              isRead: message.isRead,
              createdAt: message.createdAt,
              attachments: message.attachments || []
            }))
          : [];

        if (!isActive) return;
        setSearchResultsByChatId((prev) => ({ ...prev, [selectedChat.id]: mapped }));
      } catch (error) {
        console.error('Search messages error:', error);
      }
    }, 300);

    return () => {
      isActive = false;
      clearTimeout(timeoutId);
    };
  }, [normalizedQuery, selectedChat?.id, selectedChat?.isBackend]);

  useLayoutEffect(() => {
    if (chatContainerRef.current) {
        const hasChatChanged = selectedChat?.id !== lastSelectedChatIdRef.current;
        lastSelectedChatIdRef.current = selectedChat?.id;

        const currentCount = messagesByChatId[selectedChat?.id]?.length || 0;
        const hasNewMessages = currentCount > lastMessageCountRef.current;
        lastMessageCountRef.current = currentCount;

        if (hasChatChanged) {
            // New chat selected: always scroll to the bottom immediately
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
            isNearBottomRef.current = true;
            prevScrollHeightRef.current = null;
        } else if (prevScrollHeightRef.current !== null) {
            // Older history loaded: preserve the exact message position
            const newHeight = chatContainerRef.current.scrollHeight;
            const diff = newHeight - prevScrollHeightRef.current;
            if (diff > 0) {
                chatContainerRef.current.scrollTop = diff;
            }
            prevScrollHeightRef.current = null;
        } else if (hasNewMessages && isNearBottomRef.current) {
            // New polling message arrived while user is at the bottom: keep at bottom
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    }
  }, [messagesByChatId, selectedChat?.id]);

  const loadOlderMessages = async () => {
    const hasMore = hasMoreHistoryByChatId[selectedChat.id] !== false;
    if (isLoadingHistory || !selectedChat?.isBackend || !selectedChat.id || !hasMore) return;
    
    const currentMessages = messagesByChatId[selectedChat.id] || [];
    if (currentMessages.length === 0) return;
    const oldestMessage = currentMessages[0]; // Assuming sorted [oldest, ..., newest] in array
    
    // Note: ensure oldestMessage.createdAt is valid
    if (!oldestMessage.createdAt) return;

    setIsLoadingHistory(true);
    const token = localStorage.getItem('token');
    
    try {
        // Save scroll height to restore position after prepend
        if (chatContainerRef.current) {
            prevScrollHeightRef.current = chatContainerRef.current.scrollHeight;
        }

        const params = new URLSearchParams({
            limit: '50',
            before: oldestMessage.createdAt
        });

        const response = await fetch(`${MESSENGER_API_BASE}/api/conversations/${selectedChat.id}/messages?${params.toString()}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });

        if (response.ok) {
            const data = await response.json();
            if (Array.isArray(data) && data.length > 0) {
                const mapped = data.map((message) => ({
                    id: message.id,
                    senderId: message.senderId,
                    text: message.text,
                    isRead: message.isRead,
                    createdAt: message.createdAt,
                    attachments: message.attachments || []
                }));

                setMessagesByChatId((prev) => {
                    const existing = prev[selectedChat.id] || [];
                    const combined = [...mapped, ...existing];
                    const uniqueMap = new Map();
                    combined.forEach(msg => {
                        if (msg && msg.id) {
                            uniqueMap.set(msg.id, msg);
                        }
                    });
                    const deduplicated = Array.from(uniqueMap.values());
                    deduplicated.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
                    return {
                        ...prev,
                        [selectedChat.id]: deduplicated
                    };
                });
            } else {
                 prevScrollHeightRef.current = null;
                 // reached the absolute top of the chat history!
                 setHasMoreHistoryByChatId((prev) => ({ ...prev, [selectedChat.id]: false }));
            }
        }
    } catch (e) {
        console.error('Load history error', e);
        prevScrollHeightRef.current = null;
    } finally {
        setIsLoadingHistory(false);
    }
  };

  const handleScroll = (e) => {
    const container = e.target;
    // If scrolled to top (with small threshold)
    if (container.scrollTop < 10 && !isLoadingHistory) {
        loadOlderMessages();
    }

    // Measure if the user is scrolled near the bottom (within 150px threshold)
    const threshold = 150;
    const distanceFromBottom = container.scrollHeight - container.clientHeight - container.scrollTop;
    const nearBottom = distanceFromBottom <= threshold;
    isNearBottomRef.current = nearBottom;
    setShowScrollToBottom(!nearBottom);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);
    addFiles(files);
  };

  const addFiles = (files) => {
    const validImageFiles = files.filter(f => f.type.startsWith('image/'));
    const mapped = validImageFiles.map(file => ({
      file,
      url: URL.createObjectURL(file)
    }));
    setSelectedFiles(prev => [...prev, ...mapped]);
  };

  const handleRemoveFile = (indexToRemove) => {
    setSelectedFiles(prev => {
      const target = prev[indexToRemove];
      if (target && target.url) {
        URL.revokeObjectURL(target.url);
      }
      return prev.filter((_, i) => i !== indexToRemove);
    });
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (selectedChat && !isBlocked) {
      setIsDragging(true);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    if (selectedChat && !isBlocked) {
      const files = Array.from(e.dataTransfer.files || []);
      addFiles(files);
    }
  };

  const openLightbox = (images, index = 0) => {
    setLightbox({
      isOpen: true,
      images: images || [],
      currentIndex: index
    });
  };

  const closeLightbox = () => {
    setLightbox({
      isOpen: false,
      images: [],
      currentIndex: 0
    });
  };

  const nextLightboxImage = () => {
    setLightbox(prev => {
      if (prev.images.length === 0) return prev;
      return {
        ...prev,
        currentIndex: (prev.currentIndex + 1) % prev.images.length
      };
    });
  };

  const prevLightboxImage = () => {
    setLightbox(prev => {
      if (prev.images.length === 0) return prev;
      return {
        ...prev,
        currentIndex: (prev.currentIndex - 1 + prev.images.length) % prev.images.length
      };
    });
  };

  const handleImageLoad = () => {
    if (chatContainerRef.current && isNearBottomRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  };

  const renderMessageAttachments = (message, isOutgoing, timeLabel) => {
    const attachmentUrls = (message.attachments || []).map(resolveAttachmentUrl);
    if (attachmentUrls.length === 0) return null;

    const hasText = !!message.text;

    if (attachmentUrls.length === 1) {
      return (
        <div className={`chats-attachment-group ${isOutgoing ? 'is-outgoing' : 'is-incoming'}`}>
          <div 
            className={`message-media-container ${!hasText ? 'is-textless' : ''} ${hasText ? 'has-text' : ''}`} 
            onClick={() => openLightbox(attachmentUrls, 0)}
          >
            <img onLoad={handleImageLoad} src={attachmentUrls[0]} alt="attachment" className="message-media-single" />
            {!hasText && (
              <div className="message-media-shutter">
                <div className="message-media-time">
                  <span>{timeLabel}</span>
                  {isOutgoing && <i className={`message-media-check-icon bi ${message.isRead ? 'bi-check2-all is-read' : 'bi-check2-all is-unread'}`}></i>}
                </div>
              </div>
            )}
          </div>
          {hasText && (
            <div className={`chats-bubble ${isOutgoing ? 'is-outgoing' : 'is-incoming'} attached-text-bubble`}>
              <p className="chats-bubble-text">{message.text}</p>
              <div className="chats-bubble-meta">
                  <span className="chats-bubble-time">{timeLabel}</span>
                  {isOutgoing && <i className={`chats-bubble-status bi ${message.isRead ? 'bi-check2-all is-read' : 'bi-check2-all is-unread'}`}></i>}
              </div>
            </div>
          )}
        </div>
      );
    }

    if (attachmentUrls.length === 2) {
      return (
        <div className={`chats-attachment-group ${isOutgoing ? 'is-outgoing' : 'is-incoming'}`}>
          <div 
            className={`message-media-container ${!hasText ? 'is-textless' : ''} ${hasText ? 'has-text' : ''}`}
          >
            <div className="collage-grid-2">
              <div className="collage-tile" onClick={() => openLightbox(attachmentUrls, 0)}>
                <img onLoad={handleImageLoad} src={attachmentUrls[0]} alt="attachment 0" />
              </div>
              <div className="collage-tile" onClick={() => openLightbox(attachmentUrls, 1)}>
                <img onLoad={handleImageLoad} src={attachmentUrls[1]} alt="attachment 1" />
              </div>
            </div>
            {!hasText && (
              <div className="message-media-shutter">
                <div className="message-media-time">
                  <span>{timeLabel}</span>
                  {isOutgoing && <i className={`message-media-check-icon bi ${message.isRead ? 'bi-check2-all is-read' : 'bi-check2-all is-unread'}`}></i>}
                </div>
              </div>
            )}
          </div>
          {hasText && (
            <div className={`chats-bubble ${isOutgoing ? 'is-outgoing' : 'is-incoming'} attached-text-bubble`}>
              <p className="chats-bubble-text">{message.text}</p>
              <div className="chats-bubble-meta">
                  <span className="chats-bubble-time">{timeLabel}</span>
                  {isOutgoing && <i className={`chats-bubble-status bi ${message.isRead ? 'bi-check2-all is-read' : 'bi-check2-all is-unread'}`}></i>}
              </div>
            </div>
          )}
        </div>
      );
    }

    if (attachmentUrls.length === 3) {
      return (
        <div className={`chats-attachment-group ${isOutgoing ? 'is-outgoing' : 'is-incoming'}`}>
          <div className={`message-media-container ${!hasText ? 'is-textless' : ''} ${hasText ? 'has-text' : ''}`}>
            <div className="collage-grid-3">
              <div className="collage-tile tile-main" onClick={() => openLightbox(attachmentUrls, 0)}>
                <img onLoad={handleImageLoad} src={attachmentUrls[0]} alt="attachment 0" />
              </div>
              <div className="collage-tile" onClick={() => openLightbox(attachmentUrls, 1)}>
                <img onLoad={handleImageLoad} src={attachmentUrls[1]} alt="attachment 1" />
              </div>
              <div className="collage-tile" onClick={() => openLightbox(attachmentUrls, 2)}>
                <img onLoad={handleImageLoad} src={attachmentUrls[2]} alt="attachment 2" />
              </div>
            </div>
            {!hasText && (
              <div className="message-media-shutter">
                <div className="message-media-time">
                  <span>{timeLabel}</span>
                  {isOutgoing && <i className={`message-media-check-icon bi ${message.isRead ? 'bi-check2-all is-read' : 'bi-check2-all is-unread'}`}></i>}
                </div>
              </div>
            )}
          </div>
          {hasText && (
            <div className={`chats-bubble ${isOutgoing ? 'is-outgoing' : 'is-incoming'} attached-text-bubble`}>
              <p className="chats-bubble-text">{message.text}</p>
              <div className="chats-bubble-meta">
                  <span className="chats-bubble-time">{timeLabel}</span>
                  {isOutgoing && <i className={`chats-bubble-status bi ${message.isRead ? 'bi-check2-all is-read' : 'bi-check2-all is-unread'}`}></i>}
              </div>
            </div>
          )}
        </div>
      );
    }

    // 4 or more attachments
    const remainingCount = attachmentUrls.length - 4;
    return (
      <div className={`chats-attachment-group ${isOutgoing ? 'is-outgoing' : 'is-incoming'}`}>
        <div className={`message-media-container ${!hasText ? 'is-textless' : ''} ${hasText ? 'has-text' : ''}`}>
          <div className="collage-grid-4">
            <div className="collage-tile" onClick={() => openLightbox(attachmentUrls, 0)}>
              <img onLoad={handleImageLoad} src={attachmentUrls[0]} alt="attachment 0" />
            </div>
            <div className="collage-tile" onClick={() => openLightbox(attachmentUrls, 1)}>
              <img onLoad={handleImageLoad} src={attachmentUrls[1]} alt="attachment 1" />
            </div>
            <div className="collage-tile" onClick={() => openLightbox(attachmentUrls, 2)}>
              <img onLoad={handleImageLoad} src={attachmentUrls[2]} alt="attachment 2" />
            </div>
            <div className="collage-tile" style={{ position: 'relative' }} onClick={() => openLightbox(attachmentUrls, 3)}>
              <img onLoad={handleImageLoad} src={attachmentUrls[3]} alt="attachment 3" />
              {remainingCount > 0 && (
                <div className="message-media-blur-overlay">
                  +{remainingCount + 1}
                </div>
              )}
            </div>
          </div>
          {!hasText && (
            <div className="message-media-shutter">
              <div className="message-media-time">
                <span>{timeLabel}</span>
                {isOutgoing && <i className={`message-media-check-icon bi ${message.isRead ? 'bi-check2-all is-read' : 'bi-check2-all is-unread'}`}></i>}
              </div>
            </div>
          )}
        </div>
        {hasText && (
          <div className={`chats-bubble ${isOutgoing ? 'is-outgoing' : 'is-incoming'} attached-text-bubble`}>
            <p className="chats-bubble-text">{message.text}</p>
            <div className="chats-bubble-meta">
                <span className="chats-bubble-time">{timeLabel}</span>
                {isOutgoing && <i className={`chats-bubble-status bi ${message.isRead ? 'bi-check2-all is-read' : 'bi-check2-all is-unread'}`}></i>}
            </div>
          </div>
        )}
      </div>
    );
  };

  const popularEmojis = [
    '😀','😃','😄','😁','😆','😅','😂','🤣','😊','😇','🙂','🙃','😉','😌','😍','🥰','😘','😗','😙','😚','😋','😛','😝','😜','🤪','🤨','🧐','🤓','😎','🤩','🥳','😏','😒','😞','😔','😟','😕','🙁','☹️','😣','😖','😫','😩','🥺','😢','😭','😤','😠','😡','🤬','🤯','😳','🥵','🥶','😱','😨','😰','😥','😓','🤗','🤔','🤭','🤫','🤥','😶','😐','😑','😬','🙄','😯','😦','😧','😮','😲','🥱','😴','🤤','😪','😵','🤐','🥴','🤢','🤮','🤧','😷','🤒','🤕','🤑','🤠','😈','👿','👹','👺','🤡','💩','👻','💀','👽','👾','🤖','🎃','😺','😸','😹','😻','😼','😽','🙀','😿','😾','👋','🤚','🖐','✋','🖖','👌','🤏','✌️','🤞','🤟','🤘','🤙','👈','👉','👆','🖕','👇','☝️','👍','👎','✊','👊','🤛','🤜','👏','🙌','👐','🤲','🤝','🙏','❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣️','💕','💞','💓','💗','💖','💘','💝','🔥','✨','🌟','💫','💥','💯','🎉','🎊','🎈'
  ];

  const handleEmojiClick = (emoji) => {
    setMessageText(prev => prev + emoji);
  };

  const compressImage = (file, maxWidth, maxHeight) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob((blob) => {
          const webpName = file.name.replace(/\.[^/.]+$/, "") + ".webp";
          resolve(new File([blob], webpName, { type: 'image/webp', lastModified: Date.now() }));
        }, 'image/webp', 0.85);
        
        URL.revokeObjectURL(img.src);
      };
      img.onerror = (e) => {
        URL.revokeObjectURL(img.src);
        reject(e);
      };
    });
  };

  const handleSendMessage = async () => {
    const text = messageText.trim();
    if ((!text && selectedFiles.length === 0) || !selectedChat || isBlocked) return;

    const token = localStorage.getItem('token');
    if (!token) return;

    try {
      const hasFiles = selectedFiles.length > 0;
      let mappedMessage = null;
      let conversationId = selectedChat.id;

      if (hasFiles) {
        setIsUploading(true);
        
        const compressedFiles = await Promise.all(
          selectedFiles.map(async sf => {
            if (sf.file && sf.file.type.startsWith('image/')) {
              try {
                const compressed = await compressImage(sf.file, 1920, 1920);
                return { ...sf, file: compressed };
              } catch (err) {
                console.error('Failed to compress image:', err);
                return sf;
              }
            }
            return sf;
          })
        );

        // Build formData for the first file + optional text
        const formData = new FormData();
        if (text) {
          formData.append('Text', text);
        }
        formData.append('File', compressedFiles[0].file);

        let response;
        if (!selectedChat.isBackend) {
          response = await fetch(`${MESSENGER_API_BASE}/api/conversations/direct/${selectedChat.otherUserId}/messages/with-attachment`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`
            },
            body: formData
          });
        } else {
          response = await fetch(`${MESSENGER_API_BASE}/api/conversations/${selectedChat.id}/messages/with-attachment`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`
            },
            body: formData
          });
        }

        if (!response.ok) {
          if (response.status === 403) {
            setBlockedByChatId((prev) => ({ ...prev, [selectedChat.id]: true }));
          }
          return;
        }

        const message = await response.json();
        conversationId = message.conversationId || message.conversationID || message.ConversationId || selectedChat.id;

        // Fetch other files and attach them to the same message
        const finalAttachments = [...(message.attachments || [])];
        if (compressedFiles.length > 1) {
          for (let i = 1; i < compressedFiles.length; i++) {
            try {
              const attFormData = new FormData();
              attFormData.append('File', compressedFiles[i].file);

              const attResponse = await fetch(`${MESSENGER_API_BASE}/api/conversations/${conversationId}/messages/${message.id}/attachments`, {
                method: 'POST',
                headers: {
                  'Authorization': `Bearer ${token}`
                },
                body: attFormData
              });

              if (attResponse.ok) {
                const attDto = await attResponse.json();
                finalAttachments.push(attDto);
              }
            } catch (err) {
              console.error('Failed to attach file index ' + i, err);
            }
          }
        }

        mappedMessage = {
          id: message.id,
          senderId: message.senderId,
          text: message.text,
          isRead: message.isRead,
          createdAt: message.createdAt,
          attachments: finalAttachments
        };

      } else {
        // Send as pure JSON
        let response;
        if (!selectedChat.isBackend) {
          response = await fetch(`${MESSENGER_API_BASE}/api/conversations/direct/${selectedChat.otherUserId}/messages`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ text })
          });
        } else {
          response = await fetch(`${MESSENGER_API_BASE}/api/conversations/${selectedChat.id}/messages`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ text })
          });
        }

        if (!response.ok) {
          if (response.status === 403) {
            setBlockedByChatId((prev) => ({ ...prev, [selectedChat.id]: true }));
          }
          return;
        }

        const message = await response.json();
        conversationId = message.conversationId || message.conversationID || message.ConversationId || selectedChat.id;

        mappedMessage = {
          id: message.id,
          senderId: message.senderId,
          text: message.text,
          isRead: message.isRead,
          createdAt: message.createdAt,
          attachments: message.attachments || []
        };
      }

      // Revoke file URL objects
      selectedFiles.forEach(sf => {
        if (sf.url) URL.revokeObjectURL(sf.url);
      });
      setSelectedFiles([]);

      const newChat = {
        ...selectedChat,
        id: conversationId,
        isBackend: true,
        isPending: false,
        message: buildMessagePreview(mappedMessage.text, mappedMessage.senderId, currentUserId, selectedChat.name),
        activityAt: mappedMessage.createdAt,
        time: formatChatTime(mappedMessage.createdAt),
        unread: 0
      };

      isNearBottomRef.current = true;
      setMessagesByChatId((prev) => {
        const current = prev[conversationId] || [];
        return {
          ...prev,
          [conversationId]: [...current, mappedMessage]
        };
      });

      setChatItems((prev) => {
        const next = prev.filter((chat) => (
          chat.id !== selectedChat.id && chat.id !== conversationId && chat.otherUserId !== selectedChat.otherUserId
        ));
        return sortChatsByActivity([newChat, ...next]);
      });

      setSelectedChat(newChat);
      setMessageText('');

    } catch (error) {
      console.error('Send message error:', error);
    } finally {
      setIsUploading(false);
    }
  };

  const handleBlockUser = async () => {
    try {
        const token = localStorage.getItem('token');
        // В реальном приложении здесь должен быть ID пользователя, с которым открыт чат.
        // Для демонстрации используем заглушку или ID "Владимира" если бы он был известен.
        const userIdToBlock = selectedChat?.otherUserId || (selectedChat?.id === 3 ? "00000000-0000-0000-0000-000000000000" : "dummy-id"); 

        if (!token || !userIdToBlock) return;

        const response = await fetch(`${API_BASE}/api/Likes/blacklist/${userIdToBlock}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) return;

        const data = await response.json();
        const blocked = Boolean(data?.blocked);
        if (selectedChat?.id) {
          setBlockedByChatId((prev) => ({ ...prev, [selectedChat.id]: blocked }));
        }

        setShowBlockModal(false);
        // Здесь можно добавить логику удаления чата из списка или перенаправления
        console.log(blocked ? "Пользователь заблокирован" : "Пользователь разблокирован");
    } catch (error) {
        console.error("Ошибка блокировки:", error);
    }
  };

  const selectedAvatar = selectedChat?.avatar || FRONT_DEFAULT_AVATAR;
  const selectedName = selectedChat?.name || '';
  const selectedStatus = selectedChat?.type === 'group' ? 'групповой чат' : formatUserStatus(selectedChat?.isOnline, selectedChat?.lastSeenAt);
  const hasUnreadMessages = messageNotifications.length > 0;

  return (
    <div className="profile-page search-page chats-page">
      <main className="search-page__main flex-grow mx-auto pb-4 md:pb-0">
        <div className="w-full relative h-auto flex flex-col pt-0">
            <div className="search-page__back flex">
                <button 
                    onClick={() => {
                        if (selectedChat && window.innerWidth < 768) {
                            setSelectedChat(null);
                        } else {
                            navigate(-1);
                        }
                    }} 
                    className="search-page__back-button"
                >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="rotate-0">
                            <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      Назад
                </button>
            </div>

            <div className="chats-layout-wrapper">
                {/* Sidebar */}
                <div className={`chats-sidebar ${selectedChat ? 'hidden md:flex' : 'flex'}`}>
                    <div className="chats-sidebar-header">
                        <button className="text-[#999] text-xl bg-transparent border-none cursor-pointer hidden">
                            
                        </button>
                        <div className="chats-sidebar-search-container">
                            <svg width="17" height="17" viewBox="29 13 14 13" fill="none" xmlns="http://www.w3.org/2000/svg" className="chats-sidebar-search-icon">
                                <path d="M34.4148 12.9929C35.3967 12.9929 36.3591 13.2673 37.1933 13.7851C38.0275 14.303 38.7004 15.0437 39.136 15.9236C39.5716 16.8036 39.7526 17.7878 39.6585 18.7652C39.5645 19.7425 39.1991 20.6741 38.6037 21.4549L41.935 24.7876C42.0609 24.914 42.1341 25.0836 42.1395 25.2619C42.145 25.4403 42.0823 25.614 41.9643 25.7479C41.8463 25.8817 41.6817 25.9656 41.5041 25.9826C41.3265 25.9995 41.149 25.9482 41.0079 25.839L40.9418 25.7807L37.6092 22.4494C36.944 22.9566 36.1677 23.2981 35.3444 23.4456C34.5211 23.5932 33.6744 23.5426 32.8746 23.2979C32.0747 23.0533 31.3446 22.6218 30.7447 22.0389C30.1447 21.4561 29.6922 20.7388 29.4245 19.9464C29.1568 19.1539 29.0817 18.3091 29.2053 17.4819C29.329 16.6546 29.6478 15.8687 30.1355 15.1892C30.6232 14.5097 31.2657 13.956 32.0099 13.5741C32.754 13.1922 33.5784 12.993 34.4148 12.9929ZM34.4148 14.3976C33.3903 14.3976 32.4078 14.8046 31.6833 15.5291C30.9589 16.2535 30.5519 17.2361 30.5519 18.2606C30.5519 19.2851 30.9589 20.2677 31.6833 20.9921C32.4078 21.7166 33.3903 22.1235 34.4148 22.1235C35.4394 22.1235 36.4219 21.7166 37.1464 20.9921C37.8708 20.2677 38.2778 19.2851 38.2778 18.2606C38.2778 17.2361 37.8708 16.2535 37.1464 15.5291C36.4219 14.8046 35.4394 14.3976 34.4148 14.3976Z" fill="currentColor"/>
                            </svg>
                            <input 
                                type="text" 
                                placeholder="Поиск" 
                                value={chatFilterQuery}
                                onChange={(e) => setChatFilterQuery(e.target.value)}
                                className="chats-sidebar-search-input"
                            />
                        </div>
                    </div>

                    <div className="chats-list-container">
                      {chatItems.filter(chat => {
                          if (!chatFilterQuery.trim()) return true;
                          const q = chatFilterQuery.toLowerCase().trim();
                          return (chat.name && chat.name.toLowerCase().includes(q));
                      }).map(chat => {
                            const unreadCount = chat.isBackend
                              ? (unreadByConversation[chat.id] || 0)
                              : (chat.unread || 0);
                        return (
                        <div 
                          key={chat.id} 
                          onClick={() => { setSelectedChat(chat); setShowChatPanel(true); }}
                          className={`chats-item ${selectedChat?.id === chat.id ? 'is-active' : ''}`}
                        >
                                <div className="relative flex-shrink-0">
                                    <img src={chat.avatar} alt={chat.name} className="chats-item-avatar" onError={withAvatarFallback()} />
                                    {chat.isOnline && (
                                        <span className="absolute bottom-0 right-0 block w-3 h-3 rounded-full bg-[#10B981] border-2 border-white"></span>
                                    )}
                                </div>
                                <div className="chats-item-info">
                                    <div className="chats-item-header">
                                        <h3 className="chats-item-name">{chat.name}</h3>
                                        <span className="chats-item-time">{chat.time}</span>
                                    </div>
                                    <div className="chats-item-preview-row">
                                        <p className="chats-item-message">
                                            {typeof chat.message === 'string' && chat.message.includes(': ') ? (
                                                <>
                                                    <span className="chats-item-sender-name">{chat.message.split(': ')[0]}: </span>
                                                    {chat.message.split(': ').slice(1).join(': ')}
                                                </>
                                            ) : chat.message}
                                        </p>
                                        {unreadCount > 0 && (
                                            <span className="chats-item-unread">
                                                {unreadCount}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            );
                        })}
                    </div>
                </div>

                {/* Chat Area */}
                <div 
                    className={`chats-main-area ${!selectedChat ? 'hidden md:flex' : 'flex'}`}
                    onDragEnter={handleDragEnter}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    style={{ position: 'relative' }}
                >
                    {selectedChat ? (
                        <>
                            {isDragging && (
                        <div className="chats-drag-overlay">
                            <i className="bi bi-cloud-arrow-up"></i>
                            <span>Перетащите фотографии сюда для отправки</span>
                        </div>
                    )}
                    {/* Chat Header */}
                    <div className="chats-main-header">
                        <div className="chats-main-header-info">
                            <div 
                                onClick={() => {
                                    if (selectedChat?.otherUserId) navigate(`/user/${selectedChat.otherUserId}`);
                                    else if (selectedChat?.id) navigate(`/user/${selectedChat.id}`);
                                }}
                                className="chats-main-header-profile-link hover:opacity-80 transition-opacity"
                                title="Перейти в профиль"
                            >
                                <img src={selectedAvatar} alt={selectedName} className="chats-main-header-avatar m-0" onError={withAvatarFallback()} />
                                <div className="chats-main-header-user-info m-0">
                                    <h3 className="chats-main-header-name">{selectedName}</h3>
                                    <p className="chats-main-header-status flex items-center">
                                        {selectedChat?.isOnline && (
                                            <span className="chats-online-indicator animate-pulse"></span>
                                        )}
                                        {selectedStatus}
                                    </p>
                                </div>
                            </div>
                        </div>
                            {/* Actions buttons */}
                            <div className="flex items-center gap-1.5 md:gap-2">
                                {isSearching && (
                                    <div className="chats-inline-search-container animate-fadeIn">
                                        <button 
                                            onClick={() => setIsSearching(false)} 
                                            className="chats-inline-search-close-btn"
                                            title="Закрыть поиск"
                                        >
                                            <i className="bi bi-x-lg"></i>
                                        </button>
                                        <input 
                                            type="text" 
                                            placeholder="Поиск" 
                                            value={inlineSearchQuery} 
                                            onChange={(e) => setInlineSearchQuery(e.target.value)} 
                                            className="chats-inline-search-input" 
                                            autoFocus 
                                        />
                                        {matchedMessageIds.length > 0 && (
                                            <span className="chats-inline-search-meta">
                                                {currentSearchIndex + 1}/{matchedMessageIds.length}
                                            </span>
                                        )}
                                        <div className="flex items-center gap-1">
                                            <button 
                                                onClick={handlePrevMatch} 
                                                disabled={matchedMessageIds.length === 0} 
                                                className="chats-inline-search-btn" 
                                                title="Вверх"
                                            >
                                                <i className="bi bi-chevron-up"></i>
                                            </button>
                                            <button 
                                                onClick={handleNextMatch} 
                                                disabled={matchedMessageIds.length === 0} 
                                                className="chats-inline-search-btn" 
                                                title="Вниз"
                                            >
                                                <i className="bi bi-chevron-down"></i>
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {!isSearching && (
                                    <button
                                        onClick={() => setIsSearching(true)}
                                        className="chats-header-btn"
                                        title="Поиск по сообщениям"
                                    >
                                        <svg width="18.5" height="18.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M21 21L16.65 16.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </button>
                                )}
                                
                                <button 
                                    onClick={() => setShowBlockModal(true)}
                                    className={`chats-header-btn ${isBlocked ? 'is-blocked' : ''}`}
                                    title={isBlocked ? "Разблокировать" : "Заблокировать"}
                                >
                                   <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.25 17.3438C7.1034 17.3438 5.04473 16.491 3.52685 14.9731C2.00898 13.4553 1.15625 11.3966 1.15625 9.25C1.15625 7.1034 2.00898 5.04473 3.52685 3.52685C5.04473 2.00898 7.1034 1.15625 9.25 1.15625C11.3966 1.15625 13.4553 2.00898 14.9731 3.52685C16.491 5.04473 17.3438 7.1034 17.3438 9.25C17.3438 11.3966 16.491 13.4553 14.9731 14.9731C13.4553 16.491 11.3966 17.3438 9.25 17.3438ZM9.25 18.5C11.7033 18.5 14.056 17.5254 15.7907 15.7907C17.5254 14.056 18.5 11.7033 18.5 9.25C18.5 6.79675 17.5254 4.44397 15.7907 2.70926C14.056 0.974551 11.7033 0 9.25 0C6.79675 0 4.44397 0.974551 2.70926 2.70926C0.974551 4.44397 0 6.79675 0 9.25C0 11.7033 0.974551 14.056 2.70926 15.7907C4.44397 17.5254 6.79675 18.5 9.25 18.5Z" fill="currentColor"/>
                                    <path d="M15.4856 3.01434C15.3993 2.92776 15.2967 2.85907 15.1837 2.8122C15.0708 2.76534 14.9497 2.74121 14.8274 2.74121C14.7051 2.74121 14.584 2.76534 14.4711 2.8122C14.3581 2.85907 14.2555 2.92776 14.1692 3.01434L3.01288 14.1706C2.92644 14.2571 2.85787 14.3597 2.81109 14.4726C2.76431 14.5856 2.74023 14.7066 2.74023 14.8289C2.74023 14.9511 2.76431 15.0722 2.81109 15.1851C2.85787 15.298 2.92644 15.4006 3.01288 15.4871C3.18745 15.6617 3.42422 15.7597 3.6711 15.7597C3.79334 15.7597 3.91439 15.7357 4.02733 15.6889C4.14027 15.6421 4.24288 15.5735 4.32932 15.4871L15.4856 4.33079C15.5722 4.24443 15.6409 4.14183 15.6878 4.02888C15.7346 3.91594 15.7588 3.79485 15.7588 3.67256C15.7588 3.55028 15.7346 3.42919 15.6878 3.31624C15.6409 3.2033 15.5722 3.1007 15.4856 3.01434Z" fill="currentColor"/>
                                    </svg>
                                </button>
                            </div>
                    </div>

                    {/* Chat Messages */}
                    <div 
                        ref={chatContainerRef}
                        onScroll={handleScroll}
                        className="chats-history-container"
                    >
                        <div className="chats-messages-scroll-area">
                        {messageRows.map((row, index) => {
                          if (row.type === 'date') {
                            return (
                              <div key={row.id} className="chats-date-divider-wrapper">
                                  <span className="chats-date-divider-span">{row.label}</span>
                              </div>
                            );
                          }

                          const message = row.message;
                          const isOutgoing = isOutgoingMessage(message, currentUserId);
                          const timeLabel = message.time || formatMessageTime(message.createdAt);
                          // Compute dynamic vertical spacing margin
                          const marginTop = getMessageMarginTop(row, index, messageRows, currentUserId);
                          const isMatched = matchedMessageIds.includes(message.id);
                          const isCurrentMatch = matchedMessageIds[currentSearchIndex] === message.id;

                          const currentUserData = JSON.parse(localStorage.getItem('user') || '{}');
                          const currentUserAvatar = currentUserData.avatarUrl ? resolveAvatarUrl(currentUserData.avatarUrl) : FRONT_DEFAULT_AVATAR;
                          const messageAvatar = isOutgoing ? currentUserAvatar : selectedAvatar;

                          // Grouping logic: hide avatar if previous message is from the same sender
                          const prevRow = index > 0 ? messageRows[index - 1] : null;
                          const isSameSender = prevRow && prevRow.type === 'message' && prevRow.message.senderId === message.senderId;
                          const hideAvatar = isSameSender;

                          return (
                            <div 
                              id={`msg-${message.id}`}
                              key={message.id} 
                              className={`chats-bubble-wrapper ${isOutgoing ? 'is-outgoing' : 'is-incoming'} msg-spacing-${marginTop} ${isMatched ? (isCurrentMatch ? 'search-match-current' : 'search-match-other') : ''}`}
                            >
                                <div className="chats-message-avatar-container">
                                    {!hideAvatar && <img src={messageAvatar} alt="avatar" className="chats-message-avatar" onError={withAvatarFallback()} />}
                                </div>
                                {(() => {
                                  const hasAttachments = message.attachments && message.attachments.length > 0;
                                  if (hasAttachments) {
                                    return renderMessageAttachments(message, isOutgoing, timeLabel);
                                  }

                                  return (
                                    <div className={`chats-bubble ${isOutgoing ? 'is-outgoing' : 'is-incoming'}`}>
                                        <p className="chats-bubble-text">{message.text || ''}</p>
                                        <div className="chats-bubble-meta">
                                            <span className="chats-bubble-time">{timeLabel}</span>
                                            {isOutgoing && <i className={`chats-bubble-status bi ${message.isRead ? 'bi-check2-all is-read' : 'bi-check2-all is-unread'}`}></i>}
                                        </div>
                                    </div>
                                  );
                                })()}
                            </div>
                          );
                        })}
                        </div>
                    </div>

                        {/* Bottom Area: Previews + Input Bar */}
                        <div className="chats-bottom-area">
                            {/* Input Area */}
                            <div className="chats-input-bar-container" style={{ position: 'relative' }}>
                            {selectedFiles.length > 0 && (
                                <div className="chat-previews-container">
                                    {selectedFiles.map((sf, idx) => (
                                        <div key={idx} className="chat-preview-item" style={{ position: 'relative' }}>
                                            <img src={sf.url} alt="preview" className="chat-preview-image" />
                                            {isUploading && (
                                                <div className="chat-preview-uploading-overlay">
                                                    <svg className="progress-ring" viewBox="0 0 30 30" style={{ width: '50%', height: '50%' }}>
                                                        <circle
                                                            className="progress-ring__circle"
                                                            stroke="white"
                                                            strokeWidth="3"
                                                            fill="transparent"
                                                            r="12"
                                                            cx="15"
                                                            cy="15"
                                                        />
                                                    </svg>
                                                </div>
                                            )}
                                            <button 
                                                type="button" 
                                                className="chat-preview-remove"
                                                onClick={() => handleRemoveFile(idx)}
                                                title="Удалить"
                                            >
                                                <i className="bi bi-x"></i>
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {showScrollToBottom && (
                                <button
                                    type="button"
                                    onClick={handleJumpToBottom}
                                    className="chats-scroll-to-bottom animate-fadeIn"
                                    title="Вниз"
                                >
                                    <i className="bi bi-arrow-down"></i>
                                </button>
                            )}
                            <div className="chats-input-wrapper">
                                {showEmojiPicker && (
                                    <button
                                        type="button"
                                        className="chats-emoji-picker-overlay"
                                        onClick={() => setShowEmojiPicker(false)}
                                        aria-label="Закрыть окно выбора эмодзи"
                                    />
                                )}
                                <div ref={emojiPickerRef} className="chats-emoji-picker-anchor relative flex items-center">
                                    <button 
                                        type="button"
                                        onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                                        className="chats-input-emoji-btn cursor-pointer bg-transparent border-none p-0 flex items-center justify-center" 
                                        title="Выбрать эмодзи"
                                    >
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M5.5 6.5V6.51" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M10.5 6.5V6.51" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M5 10C5 11.6569 6.34315 13 8 13C9.65685 13 11 11.6569 11 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </button>
                                    {showEmojiPicker && (
                                        <div className="chats-emoji-picker">
                                            {popularEmojis.map((emoji, idx) => (
                                                <button
                                                    key={idx}
                                                    type="button"
                                                    onClick={() => handleEmojiClick(emoji)}
                                                    className="chats-emoji-btn"
                                                >
                                                    {emoji}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <textarea
                                    placeholder={isBlocked ? "Пользователь заблокирован, вы не можете отправлять ему сообщения" : "Напишите сообщение..."} 
                                    className="chats-input-field"
                                    value={messageText}
                                    onChange={(e) => {
                                      setMessageText(e.target.value);
                                      e.target.style.height = 'auto';
                                      e.target.style.height = `${Math.min(e.target.scrollHeight, 119)}px`;
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter' && !e.shiftKey) {
                                        e.preventDefault();
                                        handleSendMessage();
                                        e.target.style.height = 'auto';
                                      }
                                    }}
                                    disabled={isBlocked}
                                    rows={1}
                                />
                                <input 
                                    type="file" 
                                    ref={fileInputRef} 
                                    onChange={handleFileChange} 
                                    multiple 
                                    accept="image/*" 
                                    style={{ display: 'none' }} 
                                />
                                <div className="chats-input-actions-right">
                                    <button
                                        onClick={() => fileInputRef.current && fileInputRef.current.click()}
                                        className="chats-input-clip-btn"
                                        disabled={isBlocked}
                                        title="Прикрепить файл"
                                    >
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </button>
                                    <button
                                        onClick={handleSendMessage}
                                        className="chats-input-send-btn"
                                        disabled={isBlocked}
                                        title="Отправить сообщение"
                                    >
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.8141 12.1971L5.2821 13.4531C5.19551 13.4675 5.11425 13.5045 5.04649 13.5604C4.97873 13.6162 4.92686 13.6889 4.8961 13.7711L2.2991 20.7281C2.0511 21.3681 2.7201 21.9781 3.3341 21.6711L21.3341 12.6711C21.4588 12.6088 21.5636 12.5131 21.6369 12.3946C21.7102 12.276 21.7491 12.1394 21.7491 12.0001C21.7491 11.8607 21.7102 11.7241 21.6369 11.6056C21.5636 11.4871 21.4588 11.3913 21.3341 11.3291L3.3341 2.32908C2.7201 2.02208 2.0511 2.63308 2.2991 3.27208L4.8971 10.2291C4.92772 10.3115 4.97952 10.3844 5.04729 10.4404C5.11506 10.4964 5.1964 10.5335 5.2831 10.5481L12.8151 11.8031C12.8615 11.8112 12.9035 11.8354 12.9337 11.8714C12.964 11.9075 12.9806 11.953 12.9806 12.0001C12.9806 12.0471 12.964 12.0927 12.9337 12.1287C12.9035 12.1648 12.8615 12.189 12.8151 12.1971H12.8141Z" fill="currentColor"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                        </>
                    ) : (
                        <div className="chats-empty-state">
                            <span>Выберите чат</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
      </main>

      {/* Search Modal */}
      {showSearchModal && (
        <div
            className="fixed inset-0 flex justify-center items-center z-50"
            style={{ backgroundColor: 'var(--registration-modal-overlay)' }}
        >
            <div className="bg-[#FFF9F2] p-8 rounded-[20px] w-[520px] text-center shadow-lg relative">
                <h3 className="text-xl font-bold text-[#2C2C2C] mb-6 leading-snug">
                    Поиск по сообщениям
                </h3>
                <div className="bg-white rounded-[12px] h-[56px] flex items-center px-4 shadow-sm border border-[#E5E5E5]">
                    <i className="bi bi-search text-[#808080] text-[20px] mr-4"></i>
                    <input
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            setShowSearchModal(false);
                          }
                        }}
                        placeholder="Введите слово для поиска"
                        className="flex-grow h-full outline-none text-[#1A1A1A] text-[16px] font-tt-norms placeholder-[#808080]"
                    />
                </div>
                <div className="flex justify-center gap-4 mt-6">
                    <button 
                        onClick={() => setSearchQuery('')}
                        className="bg-transparent border border-[#E0E0E0] text-[#2C2C2C] px-6 py-2 rounded-xl text-lg font-medium cursor-pointer hover:bg-gray-50 transition-colors"
                    >
                        Сбросить
                    </button>
                    <button 
                        onClick={() => setShowSearchModal(false)}
                        className="bg-[#FF855F] text-white px-6 py-2 rounded-xl text-lg font-medium border-none cursor-pointer hover:opacity-90 transition-opacity"
                    >
                        Закрыть
                    </button>
                </div>
            </div>
        </div>
      )}

      {/* Block Modal */}
      {showBlockModal && (
        <div
            className="fixed inset-0 flex justify-center items-center z-50"
            style={{ backgroundColor: 'var(--registration-modal-overlay)' }}
        >
            <div
                className="p-8 rounded-[20px] w-[400px] text-center shadow-lg relative"
                style={{ backgroundColor: 'var(--chat-modal-bg)' }}
            >
                <h3
                    className="text-xl font-bold mb-8 leading-snug whitespace-pre-line"
                    style={{ color: 'var(--chat-modal-title)' }}
                >
                    {isBlocked 
                        ? 'Действительно хочешь\nразблокировать пользователя?' 
                        : 'Действительно хочешь\nзаблокировать пользователя?'}
                </h3>
                <div className="flex justify-center gap-4">
                    <button 
                        onClick={handleBlockUser}
                        className="px-8 py-2 rounded-xl text-lg font-medium border-none cursor-pointer hover:opacity-90 transition-opacity"
                        style={{
                          backgroundColor: 'var(--chat-modal-button)',
                          color: 'var(--theme-light-surface)',
                        }}
                    >
                        Да
                    </button>
                    <button 
                        onClick={() => setShowBlockModal(false)}
                        className="bg-transparent border px-8 py-2 rounded-xl text-lg font-medium cursor-pointer transition-colors"
                        style={{
                          borderColor: 'var(--chat-modal-secondary-border)',
                          color: 'var(--chat-modal-secondary-text)',
                        }}
                    >
                        Нет
                    </button>
                </div>
            </div>
        </div>
      )}
      {/* Lightbox Pop-up Viewer */}
      {lightbox.isOpen && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox}>
            <i className="bi bi-x"></i>
          </button>
          {lightbox.images.length > 1 && (
            <>
              <button 
                className="lightbox-arrow arrow-left" 
                onClick={(e) => { e.stopPropagation(); prevLightboxImage(); }}
              >
                <i className="bi bi-chevron-left"></i>
              </button>
              <button 
                className="lightbox-arrow arrow-right" 
                onClick={(e) => { e.stopPropagation(); nextLightboxImage(); }}
              >
                <i className="bi bi-chevron-right"></i>
              </button>
            </>
          )}
          <img 
            src={lightbox.images[lightbox.currentIndex]} 
            alt="fullscreen preview" 
            className="lightbox-image" 
            onClick={(e) => e.stopPropagation()} 
          />
        </div>
      )}

      <Footer />
    </div>
  );
}

export default Chats;








